var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("looker-dashboard-component", {
    key: _vm.model.keyTemplate,
    attrs: {
      maintenance: _vm.model.maintenance,
      title: _vm.model.title,
      description: _vm.model.description,
      url: _vm.model.dashboardUrl,
      breadcrumbs: [],
    },
    on: { updateDashboard: _vm.getReport },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }